import ContentWithLoader from "./ContentWithLoader";

export default ContentWithLoader;
